import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'

import { explorerApi } from '~/api/client'
import {
  analyticsUserMsnUniqueActiveAddressesKey,
  analyticsUserMsnUniqueActiveWalletsKey,
  analyticsUserMsuUniqueActiveWalletsKey,
  analyticsUserNewRegisteredUsersKey,
  analyticsUserRetentionRateKey,
  analyticsUserSticknessKey,
  analyticsUserTotalUsersKey
} from '~/api/service/query-keys.const'
import { IAnalyticsParam, IAnalyticsPeriod } from '~/types/analytics.type'
import { LineChartModel } from '~/types/model/analytics.model'

export const analyticsUserService = {
  useGetMsuUniqueActiveWallets: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getMsuUniqueActiveWallets = async () => {
      const res = await explorerApi.analyticsController.getMsuUniqueActiveWallets({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          interval: params.value.interval,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsUserMsuUniqueActiveWalletsKey, params ], getMsuUniqueActiveWallets, {
      enabled: isEnable,
    })
  },

  useGetNewRegisteredUsers: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getNewRegisteredUsers = async () => {
      const res = await explorerApi.analyticsController.getNewRegisteredUsers({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsUserNewRegisteredUsersKey, params ], getNewRegisteredUsers, {
      enabled: isEnable,
    })
  },

  useGetTotalUsers: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getTotalUsers = async () => {
      const res = await explorerApi.analyticsController.getMsuTotalUsers({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsUserTotalUsersKey, params ], getTotalUsers, {
      enabled: isEnable,
    })
  },

  useGetRetentionRate: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getRetentionRate = async () => {
      const res = await explorerApi.analyticsController.getRetentionRate({
        requestBody: {
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }

    return useQuery([ ...analyticsUserRetentionRateKey, params ], getRetentionRate, {
      enabled: isEnable,
    })
  },

  useGetUserStickiness: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getUserStickiness = async () => {
      const res = await explorerApi.analyticsController.getUserStickiness({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsUserSticknessKey, params ], getUserStickiness, {
      enabled: isEnable,
    })
  },

  useGetMsnUniqueActiveWallets: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getMsnUniqueActiveWallets = async () => {
      const res = await explorerApi.analyticsController.getMsnUniqueActiveWallet({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsUserMsnUniqueActiveWalletsKey, params ], getMsnUniqueActiveWallets, {
      enabled: isEnable,
    })
  },

  useGetUniqueActiveAddresses: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getMsnUniqueActiveAddresses = async () => {
      const res = await explorerApi.analyticsController.getMsnUniqueActiveAddress({
        requestBody: {
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsUserMsnUniqueActiveAddressesKey, params ], getMsnUniqueActiveAddresses, {
      enabled: isEnable,
    })
  }
}